import { createFileRoute } from "@tanstack/react-router";
import { LovenseLpTemplate } from "~/features/lovenseLp/LovenseLpTemplate";

export const Route = createFileRoute("/_authenticated/lp/lovense-fullcontrol")({
  component: LovenseLpTemplate,
});
